
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 57.853 57.853"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"LECTURE VIDEO","stroke":"#266fea","stroke-width":"2"}},[_c('path',{attrs:{"d":"M28.927 1A27.927 27.927 0 111 28.927 27.927 27.927 0 0128.927 1z","data-name":"Tracé 230","fill":"rgba(255,255,255,.8)"}}),_c('path',{attrs:{"d":"M24.347 17.558a1.516 1.516 0 00-1.4 1.515v19.69a1.515 1.515 0 001.254 1.515 1.51 1.51 0 001.042-.189l16.665-9.845a1.515 1.515 0 00.557-2.07 1.512 1.512 0 00-.559-.558l-16.66-9.846a1.516 1.516 0 00-.899-.212z","data-name":"Tracé 16","fill":"#fff","stroke-miterlimit":"10"}})])])
          )
        }
      }
    